import "react-responsive-carousel/lib/styles/carousel.min.css";
import "../../assets/css/views/home.css";
import { useEffect } from "react";
import { Carousel } from "react-responsive-carousel";
import Publisher from "../../components/Home/Publisher";
import { useTranslation } from "react-i18next";
import {
  IconInfo,
  ProgressIndicator,
  Button,
  IconPencil,
  IconTrash,
  Tooltip,
} from "@veneer/core";
import CreatePublisherModal from "./components/CreatePublisherModal";
import { ModalQuestion } from "../SellOut/SellOutComponent/ModalQuestion";
import useHomeViewModel from "./useHomeViewModel";

export default function Home() {
  const [t] = useTranslation("global");
  const {
    newPublishers,
    showLoading,
    openCreatePost,
    showDeleteModal,
    deletePostID,
    updatePostID,
    isUpdate,
    userRoleIdLogged,
    userFullName,
    canCreatePostIds,
    getPublishers,
    handleOpenCreatePost,
    handleSetLoading,
    handleSetIsUpdate,
    handleSetUpdatePostID,
    handleDeleteButtonClick,
    handleDeletePost,
    handleCloseCreatePost,
    handlePublisher,
  } = useHomeViewModel();

  useEffect(() => {
    if (!openCreatePost) {
      handleSetLoading(false);
      getPublishers(true);
    }
  }, [openCreatePost]);

  return (
    <div>
      <div style={{ padding: "20px" }}>
        <div className="publisher-title">
          <h4>{t("header.home")}</h4>
          {canCreatePostIds.includes(userRoleIdLogged) ? (
            <Button
              small
              appearance="secondary"
              onClick={() => handleOpenCreatePost(true)}
            >
              {t("header.createPost")}
            </Button>
          ) : null}
        </div>
        <div>
          <CreatePublisherModal
            openCreatePost={openCreatePost}
            handleOpenCreatePost={handleOpenCreatePost}
            isUpdate={isUpdate}
            updatePostID={updatePostID}
          />
        </div>
        <div className="carousel">
          {showLoading ? (
            newPublishers.length > 0 ? (
              newPublishers.map((publisher, index) => {
                return (
                  <Carousel
                    key={index}
                    autoPlay
                    infiniteLoop
                    emulateTouch
                    showIndicators={true}
                    showArrows
                    showStatus
                    showThumbs={false}
                    interval={10000}
                  >
                    {publisher.map((p, index) => (
                      <div key={index}>
                        {userFullName === p.postOwner ? (
                          <div className="icon-title">
                            <Tooltip
                              placement="bottom"
                              content={<>{t("header.edit")}</>}
                              id="tooltip"
                            >
                              <Button
                                style={{
                                  marginRight: "1rem",
                                  marginBottom: "4px",
                                }}
                                leadingIcon={<IconPencil />}
                                onClick={() => {
                                  handleOpenCreatePost(true);
                                  handleSetIsUpdate(true);
                                  handleSetUpdatePostID(p.postID);
                                }}
                              />
                            </Tooltip>
                            <Tooltip
                              placement="bottom"
                              content={<>{t("header.delete")}</>}
                              id="tooltip"
                            >
                              <Button
                                style={{
                                  marginRight: "2.4rem",
                                  marginBottom: "4px",
                                }}
                                appearance="secondary"
                                colorScheme="negative"
                                leadingIcon={<IconTrash />}
                                onClick={() =>
                                  handleDeleteButtonClick(p.postID)
                                }
                              />
                            </Tooltip>
                          </div>
                        ) : null}
                        <Publisher
                          key={p.postID}
                          publisher={p}
                          updatePublisher={handlePublisher}
                        />
                      </div>
                    ))}
                  </Carousel>
                );
              })
            ) : (
              <div style={{ textAlign: "center" }}>
                <IconInfo size={72} /> <br /> {t("header.thereAreNoPost")}
              </div>
            )
          ) : (
            <div className="container">
              <div className="vertical-center">
                <ProgressIndicator
                  appearance="circular"
                  behavior="indeterminate"
                />
              </div>
            </div>
          )}
        </div>
      </div>
      <ModalQuestion
        id="modal-delete"
        setOpenCloseModal={handleCloseCreatePost}
        openModal={showDeleteModal}
        titleMessage={t("modal.warningTitle")}
        message={t("modal.messageDeletePost")}
        onClickYes={() => handleDeletePost(deletePostID)}
        onClickNo={handleCloseCreatePost}
        titleButtonYes={t("header.delete")}
        titleButtonNo={t("header.cancel")}
      />
    </div>
  );
}
